"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'chat.teaser.cta.label': 'Fai una domanda',
    'chat.teaser.default.prompt1.description': 'Di cosa è composta l\'atmosfera di Marte?',
    'chat.teaser.default.prompt1.text': 'Di cosa è composta l\'atmosfera di Marte?',
    'chat.teaser.default.prompt2.description': 'Quanto veloce può correre un cavallo?',
    'chat.teaser.default.prompt2.text': 'Quanto veloce può correre un cavallo?',
    'chat.teaser.default.prompt3.description': 'Come cambiare una gomma a terra?',
    'chat.teaser.default.prompt3.text': 'Come cambiare una gomma a terra?',
};
